import(/* webpackMode: "eager" */ "/home/runner/work/vc-fullfillment/vc-fullfillment/apps/web/src/app/global-error.tsx");
